import React, { Component } from "react";
import { Link } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';

import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Label,
  Row,
} from "reactstrap";

// import backGround_images
import build from "../../assets/images/real/build.png";
import workingWithComputerImg from '../../assets/images/illustrator/working_with_computer.svg';
import delivery2 from '../../assets/images/delivery2.svg'

//Import Icons
import FeatherIcon from "feather-icons-react";

export default class Section extends Component {
  render() {
    return (
      <React.Fragment>
        <section
          className="bg-half-170 bg-light d-table w-100"
          style={{ background: `url(${build}) bottom no-repeat`, marginTop:'-5%' }}
        >
          <Container>
            <Row className="align-items-center mt-5">
              <Col xl={8} lg={7} md={6}>
                <div className="title-heading" >
                  {/* <span className="badge rounded-pill bg-soft-success">
                    Vision
                  </span> */}
                  <h4 className="heading my-3">
                  Turtl Delivery – Redefining Logistics with Speed & Efficiency<br />
                  </h4>
                  <h2>
                  Stretching The Boundaries – Quick delivery for cities of all sizes.
                  </h2>
                  <p className="para-desc text-muted">
                  We are revolutionizing quick-commerce by offering rapid, convenient, 
                  and reliable delivery services across Tier 1, Tier 2, and Tier 3 cities. 
                  Whether it’s daily essentials, specialty products, or business logistics, 
                  Turtl Delivery ensures seamless and efficient transportation to meet the 
                  needs of consumers and enterprises alike.
                  </p>

                  <ul className="list-unstyled text-muted">
                  <li className="mb-1">
                    <span className="h5 me-2" style={{color:"#018ABF"}}>
                      <i className="uil uil-check-circle align-middle"></i>
                    </span>
                    Speed & Efficiency – Our AI-driven logistics network optimizes delivery routes for the fastest and most cost-effective fulfillment.
                  </li>
                  <li className="mb-1">
                    <span className="h5 me-2" style={{color:"#018ABF"}}>
                      <i className="uil uil-check-circle align-middle"></i>
                    </span>
                    Widespread Coverage – From bustling metros to emerging urban hubs, we ensure last-mile connectivity for businesses and individuals.
                  </li>
                  <li className="mb-1">
                    <span className="h5 me-2" style={{color:"#018ABF"}}>
                      <i className="uil uil-check-circle align-middle"></i>
                    </span>
                    Sustainable & Smart – We prioritize eco-friendly transportation solutions to reduce our carbon footprint while maintaining high-speed deliveries.
                  </li>
                  <li className="mb-1">
                    <span className="h5 me-2" style={{color:"#018ABF"}}>
                      <i className="uil uil-check-circle align-middle"></i>
                    </span>
                    Seamless User Experience – Live tracking, real-time notifications, and flexible delivery options put control in your hands.
                  </li>
                </ul>
                <h4>Join us as we disrupt the delivery industry with technology, efficiency, and innovation.</h4>
                


                  {/* <div className="mt-4 pt-2"> */}
                    {/* <Link to="#aboutus" className="btn btn-primary m-1">
                      Explore Now
                    </Link> */}
                    {/* <HashLink smooth to='#aboutus' className="btn btn-primary m-1" style={{backgroundColor:"#018ABF", borderColor: "#018ABF"}}> Explore </HashLink> */}
                  {/* </div> */}
                </div>
              </Col>

              {/* <Col lg={5} md={5} className="order-2 order-md-1 mt-4 pt-2 mt-sm-0 pt-sm-0">
                            <img src={workingWithComputerImg} className="img-fluid" alt="" />
                        </Col> */}

              <Col xl={4} lg={5} md={6} className="mt-4 pt-2 mt-sm-0 pt-sm-0">
              <img src={delivery2} className="img-fluid" alt="" />
                {/* <Card className="shadow rounded border-0 ms-lg-4">
                  <CardBody>
                    <h5 className="card-title text-center">
                      Get 30 days FREE Trial
                    </h5>

                    <Form className="login-form mt-4">
                      <Row>
                        <Col md={12}>
                          <div className="mb-3">
                            <Label className="form-label">
                              First name <span className="text-danger">*</span>
                            </Label>
                            <div className="form-icon position-relative">
                              <i>
                                <FeatherIcon
                                  icon="user"
                                  className="fea icon-sm icons"
                                />
                              </i>
                              <input
                                type="text"
                                className="form-control ps-5"
                                placeholder="First Name"
                                name="s"
                                required=""
                              />
                            </div>
                          </div>
                        </Col>
                        <Col md={12}>
                          <div className="mb-3">
                            <Label className="form-label">
                              Your Email <span className="text-danger">*</span>
                            </Label>
                            <div className="form-icon position-relative">
                              <i>
                                <FeatherIcon
                                  icon="mail"
                                  className="fea icon-sm icons"
                                />
                              </i>
                              <input
                                type="email"
                                className="form-control ps-5"
                                placeholder="Email"
                                name="email"
                                required=""
                              />
                            </div>
                          </div>
                        </Col>
                        <Col md={12}>
                          <div className="mb-3">
                            <Label className="form-label">
                              Password <span className="text-danger">*</span>
                            </Label>
                            <div className="form-icon position-relative">
                              <i>
                                <FeatherIcon
                                  icon="key"
                                  className="fea icon-sm icons"
                                />
                              </i>
                              <input
                                type="password"
                                className="form-control ps-5"
                                placeholder="Password"
                                required=""
                              />
                            </div>
                          </div>
                        </Col>                        
                        <Col md={12}>
                          <div className="mb-3">
                            <div className="form-check">
                              <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                <label className="form-check-label" htmlFor="flexCheckDefault">
                                  I Accept <Link to="#" className="text-primary">Terms And Condition</Link>
                                </label>
                            </div>
                          </div>
                        </Col>
                        <Col md={12}>
                          <div className="d-grid">
                            <button className="btn btn-block btn-primary">
                              Register
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card> */}
              </Col>
              
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}
